import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppDownloadButtonComponent } from './app-download-button.component';

@NgModule({
  declarations: [AppDownloadButtonComponent],
  imports: [TranslateModule],
  exports: [AppDownloadButtonComponent],
})
export class AppDownloadButtonModule {}
